// const baseUrl = "http://127.0.0.1:8000/acoolapp"
const baseUrl = "https://bsh.api-boyahane.smartopt.com.tr/acoolapp"

// Beta ortamı: CORS proxy + beta backend
export const betaBaseUrl = "https://bsh.api-boyahane.smartopt.com.tr/beta/acoolapp"


export default baseUrl